"use client";

import { BSRExclamation } from "./bsr/BSRExclamation";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Exclamation as LegacyExclamation } from "./legacy/Exclamation";

export const Exclamation = createBSRExperimentIcon(
  LegacyExclamation,
  BSRExclamation
);
